import { render } from "./FormEditPage.vue?vue&type=template&id=f87ce8d8&scoped=true"
import script from "./FormEditPage.vue?vue&type=script&lang=js"
export * from "./FormEditPage.vue?vue&type=script&lang=js"

import "./FormEditPage.vue?vue&type=style&index=0&id=f87ce8d8&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87ce8d8"]])

export default __exports__